<template>
<div style="width:100%; padding-top: 60px">
  <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
      <screenButton class="screenButton"></screenButton>
    </div>
  </div>

  <b-table v-if="unitCategory==='1'" class="bgc-dark" head-variant="dark" responsive bordered
           :items="items" :fields="fields1" foot-clone>
    <template v-slot:head()="scope">
      <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
        {{ scope.label }}
      </div>
    </template>
    <template v-slot:cell(index)="data">
      {{ data.index + 1 }}
    </template>
    <template v-slot:cell(unitPrice)="data">
      {{ Number(data.item.unitPrice).toFixed(6) }}
    </template>
    <template v-slot:cell(approvedWorkload)="data">
      {{ Number(data.item.approvedWorkload).toFixed(8) }}
    </template>
    <template v-slot:cell(attachList)="data">
      <div style="color: #5d94f8;" v-for="key in data.item.attachList" :key="key.id" @click="$viewAttach(key)">{{ key.name }}</div>
    </template>
    <template v-slot:cell(estimateAmount)="data">
      {{ Number(data.item.estimateAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(remarks)="data">
      <div @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
    </template>

    <template v-slot:table-colgroup="scope">
      <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.width }"
      >
    </template>
    <template v-slot:foot()="scope">
      <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
    </template>
    <template v-slot:foot(index)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
    </template>
    <template v-slot:foot(approvedWorkload)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'approvedWorkload')}}</div>
    </template>
    <template v-slot:foot(estimateAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'estimateAmount')}}</div>
    </template>
  </b-table>
  <b-table v-if="unitCategory==='2'" class="bgc-dark" head-variant="dark" responsive bordered
           :items="items" :fields="fields2" foot-clone>
    <template v-slot:head()="scope">
      <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
        {{ scope.label }}
      </div>
    </template>
    <template v-slot:cell(index)="data">
      {{ data.index + 1 }}
    </template>
    <template v-slot:cell(estimateUnitPrice)="data">
      {{ (Number(data.item.estimateUnitPrice)).toFixed(2) }}
    </template>
    <template v-slot:cell(unitPrice)="data">
      {{ (Number(data.item.unitPrice) * 100).toFixed(2) }}
    </template>
    <template v-slot:cell(estimateNumber)="data">
      {{ (Number(data.item.estimateNumber) * 100).toFixed(8) }}
    </template>
    <template v-slot:cell(approvedWorkload)="data">
      {{ Number(data.item.approvedWorkload).toFixed(8) }}
    </template>
    <template v-slot:cell(attachList)="data">
      <div style="color: #5d94f8;" v-for="key in data.item.attachList" :key="key.id" @click="$viewAttach(key)">{{ key.name }}</div>
    </template>
    <template v-slot:cell(estimateAmount)="data">
      {{ Number(data.item.estimateAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(remarks)="data">
      <div @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
    </template>

    <template v-slot:table-colgroup="scope">
      <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.width }"
      >
    </template>
    <template v-slot:foot()="scope">
      <div class="text-nowrap" :style="{textAlign:'center'}"></div>
    </template>
    <template v-slot:foot(index)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
    </template>
    <template v-slot:foot(approvedWorkload)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'approvedWorkload')}}</div>
    </template>
    <template v-slot:foot(estimateAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'estimateAmount')}}</div>
    </template>
  </b-table>
  <b-table v-if="unitCategory==='3'" class="bgc-dark" head-variant="dark" responsive bordered
           :items="items" :fields="fields3" foot-clone>
    <template v-slot:head()="scope">
      <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
        {{ scope.label }}
      </div>
    </template>
    <template v-slot:cell(index)="data">
      {{ data.index + 1 }}
    </template>
    <template v-slot:cell(attachList)="data">
      <div style="color: #5d94f8;" v-for="key in data.item.attachList" :key="key.id" @click="$viewAttach(key)">{{ key.name }}</div>
    </template>
    <template v-slot:cell(estimateAmount)="data">
      {{ Number(data.item.estimateAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(remarks)="data">
      <div @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
    </template>

    <template v-slot:table-colgroup="scope">
      <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.width }"
      >
    </template>
    <template v-slot:foot()="scope">
      <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
    </template>
    <template v-slot:foot(index)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
    </template>
    <template v-slot:foot(estimateAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'estimateAmount')}}</div>
    </template>
  </b-table>
</div>
</template>

<script>
import {Decimal} from "decimal.js";

export default {
  name: "contractWorkloadEstimateDetail",
  data(){
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'unitPriceName', label: '单价名称', width: '120px'},
        {key: 'unit', label: '单位', width: '80px'},
        {key: 'unitPrice', label: '单价', width: '130px'},
        {key: 'approvedWorkload', label: '工作量', width: '130px'},
        {key: 'estimateAmount', label: '金额(元)', width: '100px'},
        {key: 'attachList', label: '附件', width: '130px'},
        {key: 'remarks', label: '备注', width: '180px'},
      ],
      fields2: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'unitPriceName', label: '比例名称', width: '120px'},
        {key: 'unit', label: '单位', width: '80px'},
        {key: 'estimateUnitPrice', label: '单价', width: '80px'},
        {key: 'estimateNumber', label: '数量', width: '80px'},
        {key: 'approvedWorkload', label: '金额(元)', width: '110px'},
        {key: 'unitPrice', label: '比例', width: '80px'},
        {key: 'estimateAmount', label: '佣金(元)', width: '100px'},
        {key: 'attachList', label: '附件', width: '130px'},
        {key: 'remarks', label: '备注', width: '180px'},
      ],
      fields3: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'unitPriceName', label: '单价名称', width: '120px'},
        {key: 'estimateAmount', label: '金额(元)', width: '110px'},
        {key: 'attachList', label: '附件', width: '130px'},
        {key: 'remarks', label: '备注', width: '180px'},
      ],
      items: [],
      unitCategory: '',
    }
  },
  created(){
    this.items = JSON.parse(this.$route.query.data)
    this.unitCategory = this.$route.query.unitCategory
  },
  methods: {
    init(){

    },
    goBack(){
      this.$router.back()
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass(){
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
